// @flow

import React, { Component } from 'react';
import Relay from 'react-relay';
import moment from 'moment';
import Select from 'react-select';
import styler from 'react-styling';
import { FormGroup, InputGroup, FormControl, Row, Col, Button, Modal } from 'react-bootstrap/lib';

import { DatePicker, DraggableModal } from '../index';
import { filterNotNullEdgeNodes } from '../../libs/Extract';
import { CONTACTS_EVENT_PAGE_SIZE } from '../../../../config';
import { logError } from '../../libs/Logger';
import { setEventDateAndTime, syncDatesAndTime } from '../../libs/Time';
import CreateEventMutation from '../../Mutations/CreateEventMutation';

const style = styler `
  Body
    padding: 20px
    background-color: #FFF
  Header
    background-color: #0A152D
    color: #FFF
    padding: 15px 20px
    border-radius: 8px 8px 0 0
  Title
    font-size: 20px
  Datepicker
    border: 0
  Button
    background-color: #F5F5F5
    padding: 7px 15px
  Footer
    background-color: #FFF
  IconCalendar
    color: #497BEB
`;

function validate(title) {
  return {
    title: title.length === 0,
  };
}

class CreateEventModal extends Component {
  constructor(props) {
    super(props);
    const chair = this.props.contact;
    chair.value = chair.email; // value for select
    chair.label = chair.displayName; // label for select

    this.state = {
      title: '',
      notes: '',
      chair: this.props.contact,
      dateSelectedToCreateEvent: props.dateSelectedToCreateEvent,
      showStartDateCalendar: false,
      showEndDateCalendar: false,
      errors: {
        title: false,
      },
      contactsSelected: this.props.contactsSelected,
    };
  }
  state: {
    title: string,
    notes: string,
    chair: Object,
    dateSelectedToCreateEvent: Object,
    showStartDateCalendar: boolean,
    showEndDateCalendar: boolean,
    errors: Object,
    contactsSelected: Array<Object>,
  };

  props: {
    dateSelectedToCreateEvent: Object, // { end: date, start: date, hour: number}
    closeCreateEventModal: Function,
    LocalLanguageData: Object,
    isCreateEventModalOpen: boolean,
    changeSelectedTo: Function,
    contactsSelected: any,
    viewer: Object,
    relay: Object,
    contact: Object,
    forceFetch: Function,
    parent?: string,
  }

  _saveEvent = (contactsSelected, start, end) => {
    const errors = validate(this.state.title);
    const formNotValid = Object.keys(errors).some(x => errors[x]);
    if (formNotValid) {
      this.setState({
        errors,
      });
      return;
    }
    const eventData = {
      chair: this.state.chair,
      required: contactsSelected, // props.contactsSelected
      title: this.state.title,
      startDate: moment(start),
      endDate: moment(end),
      body: this.state.notes,
      // moment guess might not be accurate. When the Intl API is supported, it might even give non
      // IANA standard TZs like 'CET' for Oslo in summer time (which should really be CEST, or ideally Europe/Oslo)
      // When the Intl API is not supported, momentjs attempts to guess and always return the city with the
      // greater population (i.e for Oslo at summer time that would be Europe/Paris). 'Europe/Paris'is in
      // fact fine as the offsets are respected, but might not happen if the browser does support the Intl API.
      // In the event of having a wrong TZ info the backend will default to UTC so even if the original TZ
      // is lost at least the dates would still be correct.
      // This can be improved by having input from the user.
      timezone: moment.tz.guess(),
    };

    this.props.relay.commitUpdate(
      new CreateEventMutation({
        eventData,
      }),
      {
        onFailure: (error) => { logError(error); },
        onSuccess: () => { this.props.forceFetch(); },
      }
    );
  }
  _changeAttendees = (elm) => {
    const emailsArray = [];
    elm.forEach(resource => {
      if (resource.value) {
        emailsArray.push(resource.value);
      } else if (resource.email) {
        emailsArray.push(resource.email);
      }
    });
    this.setState({
      contactsSelected: elm,
    });
    // call changeSelectedTo() with empty array fetch all resources events.
    if (this.props.parent === 'scheduler') {
      if (emailsArray.length > 0) {
        this.props.changeSelectedTo(emailsArray);
      }
    }
  }
  // text search for contact
  _searchForResource = (elm) => {
    if (elm) {
      this.props.relay.setVariables({
        textFilter: elm,
      });
    }
  }

  _handleTitleChange = (event: Object) => {
    this.setState({ title: event.target.value });
  }

  _handleNotesChange = (event: Object) => {
    this.setState({ notes: event.target.value });
  }

  _changeSelectedChair = (elm) => {
    let value = {};
    if (elm) {
      value = elm;
    }
    this.setState({ chair: value });
  }

  _handleTimePickerChange = (whichTimePicker: string, event: Object) => {
    const time = event.target.value;
    if (whichTimePicker === 'startTime') {
      const date = moment(this.state.dateSelectedToCreateEvent.start).format('YYYYMMDD');
      const newDate = setEventDateAndTime(date, time);
      const { start, end } = syncDatesAndTime(newDate, moment(this.state.dateSelectedToCreateEvent.end), 'start');
      setTimeout(() => {
        this.setState({
          dateSelectedToCreateEvent: {
            start: start.format(),
            end,
          },
        });
      }, 250);
    } else {
      const date = moment(this.state.dateSelectedToCreateEvent.end).format('YYYYMMDD');
      const newDate = setEventDateAndTime(date, time);
      const { start, end } = syncDatesAndTime(moment(this.state.dateSelectedToCreateEvent.start), newDate, 'end');
      setTimeout(() => {
        this.setState({
          dateSelectedToCreateEvent: {
            end: end.format(),
            start,
          },
        });
      }, 250);
    }
  }

  _handleDatePickerChange = (whichDatePicker, pickedDate) => {
    if (whichDatePicker === 'startDate') {
      const time = moment(this.state.dateSelectedToCreateEvent.start).format('HH:mm');
      const newDate = setEventDateAndTime(pickedDate.format('YYYYMMDD'), time);
      const { start, end } = syncDatesAndTime(newDate, moment(this.state.dateSelectedToCreateEvent.end), 'start');
      this.setState({
        dateSelectedToCreateEvent: {
          start: start.format(),
          end,
        },
        showStartDateCalendar: false,
      });
    } else {
      const time = moment(this.state.dateSelectedToCreateEvent.end).format('HH:mm');
      const newDate = setEventDateAndTime(pickedDate.format('YYYYMMDD'), time);
      const { start, end } = syncDatesAndTime(moment(this.state.dateSelectedToCreateEvent.start), newDate, 'end');
      this.setState({
        dateSelectedToCreateEvent: {
          end: end.format(),
          start,
        },
        showEndDateCalendar: false,
      });
    }
  }

  _toggleCalendar = (whichCalendr: string) => {
    whichCalendr === 'endDateCalendar' ?
    this.setState({
      showStartDateCalendar: false,
      showEndDateCalendar: !this.state.showEndDateCalendar,
    }) :
    this.setState({
      showEndDateCalendar: false,
      showStartDateCalendar: !this.state.showStartDateCalendar,
    });
  }

  render() {
    const { LocalLanguageData } = this.props;
    const { start, end } = this.state.dateSelectedToCreateEvent;
    const { errors } = this.state;
    const { contacts } = this.props.viewer;
    const contactList = filterNotNullEdgeNodes(contacts);
    const contactsAll = [];
    if (contacts) {
      contactList.forEach(contact => {
        const contactCopy = contact;
        contactCopy.value = contact.email;
        contactCopy.label = contact.displayName;
        contactsAll.push(contactCopy);
      });
    }
    // to add label and value keys needed by <Select />
    const contactsSelected = this.state.contactsSelected.map(contact => {
      const contactModified = {
        label: contact.displayName || contact.label,
        value: contact.email || contact.value,
      };
      return contactModified;
    });

    return (
      <Modal dialogComponentClass={DraggableModal} enforceFocus={false} backdrop="static" show={this.props.isCreateEventModalOpen} onHide={this.props.closeCreateEventModal} dialogClassName="draggable-modal" className="createeventmodal">
        <Modal.Header closeButton style={style.Header}>
          <Modal.Title style={style.Title}>{LocalLanguageData.create_new_event}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={style.Body}>
          <form>
            <FormGroup controlId="formBasicText">
              <label>{LocalLanguageData.required}</label>
              <Select
                name="form-field-name"
                multi={true}
                options={contactsAll}
                onInputChange={this._searchForResource}
                onChange={this._changeAttendees}
                value={contactsSelected}
                clearable={false}
                className="requiredlist"
              />
            </FormGroup>
            <FormGroup controlId="formBasicText">
              <label>{LocalLanguageData.chair}</label>
              <Select
                options={contactsAll}
                onChange={this._changeSelectedChair}
                onInputChange={this._searchForResource}
                value={this.state.chair}
                clearable={false}
                className={'test'}
                className="chairlist"
              />
            </FormGroup>
            <FormGroup controlId="eventTitle">
              <label>{LocalLanguageData.title}</label>
              <FormControl
                className={errors.title ? 'form-error' : ''}
                type="text"
                placeholder={LocalLanguageData.title}
                onChange={this._handleTitleChange}
                value={this.state.title}
              />
            </FormGroup>
            <Row>
              <Col sm={6}>
                <FormGroup controlId="eventStartDate">
                  <label>{LocalLanguageData.start}</label>
                  <InputGroup>
                    <FormControl
                      value={moment(start).format('L')}
                      type="text"
                      readOnly
                      style={style.Datepicker}
                    />
                    <InputGroup.Button>
                      <Button style={style.Button} onClick={() => this._toggleCalendar('startDateCalendar')}><i style={style.IconCalendar} className="fa fa-calendar-o" /></Button>
                    </InputGroup.Button>
                  </InputGroup>
                </FormGroup>
              </Col>
              <Col sm={6}>
                { this.state.showStartDateCalendar ?
                  <DatePicker
                    date={start}
                    handleDatePickerChange={(event) => { this._handleDatePickerChange('startDate', event); }}
                  />
                : null }
                <FormGroup controlId="eventStartTime">
                  <label>{LocalLanguageData.time}</label>
                  <FormControl
                    type="time"
                    value={moment(start).format('HH:mm')}
                    onChange={(event) => { this._handleTimePickerChange('startTime', event); }}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <FormGroup controlId="formBasicText">
                  <label>{LocalLanguageData.end}</label>
                  <InputGroup>
                    <FormControl
                      value={moment(end).format('L')}
                      type="text"
                      readOnly
                      style={style.Datepicker}
                    />
                    <InputGroup.Button>
                      <Button style={style.Button} onClick={() => this._toggleCalendar('endDateCalendar')}><i style={style.IconCalendar} className="fa fa-calendar-o" /></Button>
                    </InputGroup.Button>
                  </InputGroup>
                </FormGroup>
              </Col>
              <Col sm={6}>
                { this.state.showEndDateCalendar ?
                  <DatePicker
                    date={end}
                    handleDatePickerChange={(event) => { this._handleDatePickerChange('endDate', event); }}
                  />
                : null }
                <FormGroup controlId="eventEndTime">
                  <label>{LocalLanguageData.time}</label>
                  <FormControl
                    type="time"
                    value={moment(end).format('HH:mm')}
                    onChange={(event) => { this._handleTimePickerChange('endTime', event); }}
                  />
                </FormGroup>
              </Col>
            </Row>
            <FormGroup controlId="formBasicText">
              <label>{LocalLanguageData.notes}</label>
              <FormControl
                className={'form-control'}
                componentClass="textarea"
                placeholder={LocalLanguageData.notes}
                value={this.state.notes}
                onChange={this._handleNotesChange}
              />
            </FormGroup>
          </form>
        </Modal.Body>
        <Modal.Footer style={style.Footer}>
          <Button bsStyle="primary" onClick={() => this._saveEvent(this.state.contactsSelected, start, end)}>{LocalLanguageData.send}</Button>
          <Button onClick={this.props.closeCreateEventModal}>{LocalLanguageData.close}</Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default Relay.createContainer(CreateEventModal, {
  initialVariables: {
    textFilter: null,
    pageSize: CONTACTS_EVENT_PAGE_SIZE,
  },
  fragments: {
    viewer: () => Relay.QL`
    fragment on Viewer {
      contacts(first: $pageSize, text: $textFilter) {
        edges {
          node {
            displayName
            email
          }
        }
      }
    }
    `,
  },
});



// WEBPACK FOOTER //
// ./src/js/Components/Scheduler/CreateEventModal.js